
































import { Step } from '../models';

import { UiRippleInk, UiTooltip } from './keen-ui';

export default {
  name: 'stepper',
  props: {
    steps: {
      type: [Number, Array], // Step[]
      required: true
    },
    value: {
      type: [Number, String],
      required: true
    },
    color: {
      type: String,
      default: 'primary'
    },
    displayLabelsOnTooltip: {
      type: Boolean,
      default: false
    }
  },
  components: {
    UiTooltip,
    UiRippleInk
  },
  methods: {
    getStepId: function (step): (string | number) {
      return (step.id || step);
    },
    getStepClasses: function (step: (Step | number)) {
      return {
        'epb-stepper__step--selected': this.isStepSelected(step),
        'epb-stepper__step--disabled': this.isStepDisabled(step),
        'epb-stepper__step--valid': this.isStepValid(step),
        'epb-stepper__step--invalid': this.isStepInvalid(step)
      };
    },
    isStepSelected: function (step: (Step | number)): boolean {
      return (this.getStepId(step) === this.value);
    },
    isStepDisabled: function (step): boolean {
      return !!step.disabled;
    },
    isStepValid: function (step): boolean {
      return !!step.valid;
    },
    isStepInvalid: function (step): boolean {
      return (step.valid === false);
    },
    onStepClick: function (step: (Step | number)): void {
      if (this.isStepDisabled(step)) {
        return;
      }
      this.$emit('input', this.getStepId(step));
    },
    getStepIcon: function (step: (Step | number)): string {
      if (this.isStepSelected(step)) {
        if (this.isStepValid(step)) {
          return 'accept';
        } else if (this.isStepInvalid(step)) {
          return 'close';
        }
      }
    }
  }
};

